
 import React, { Component } from 'react';
 import Header from '../header/newheader'
 import Footer from '../footer/newfooter';
 import {BASE} from '../api/api'
 import Axios from 'axios'
 import ReactHtmlParser from 'react-html-parser';

 
 class Banking extends Component {
     constructor(props) {
        super(props);
        this.state={
            contact: ''
            
        } 
       }
        getlink(){
          if(!this.logincheck()){
            this.props.history.push('/login?redir=banking_regulation')
          }
      }

        logincheck(){
            let login = localStorage.getItem('token');
            if (login && login != null) {
                return true
            }
            else
                return false
        }
       componentWillMount(){
        this.getlink()
        Axios(BASE+'jsonapi/node/page?filter[title]=Banking Regulations', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    })
        .then((data) => {
            this.setState({
                contact:data.data.data[0].attributes.body.processed
            })
        })
        .catch((err) => {
            console.log('not found')
        })
    }    
 
 render() {
     
     return (
     <div className='contact_rea'>
          <Header/>
          <body className="listing">
    
    
    <div className="page-title">
      <div className="title-wrapper">
        <div  className="container ">
          <h1 className="page-header">Banking Regulations</h1>
        </div>
      </div>
    </div>
    
    <div className="main-content aboutcis">
      <div id="newpad2233" className="container basicpage">
        <div className="row">
        
        {ReactHtmlParser(this.state.contact?this.state.contact:'')}

        </div>
      </div>
    </div>
    
  
  </body>
  <Footer/> 
    </div>  
            )
    
    
}

}

export default Banking;